const ReturnIcon = () => {
    return (
        <svg
            id="Group_7935"
            data-name="Group 7935"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 16 16"
        >
            <g id="Group_7933" data-name="Group 7933">
                <path
                    id="Path_3327"
                    data-name="Path 3327"
                    d="M.5,7.318a6.818,6.818,0,1,0,9.536-6.255m0,0,2-.563m-2,.563.43,2.059"
                    transform="translate(0.182 0.182)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default ReturnIcon;
